var map = {
	"./Backg-1.jpg": 7543,
	"./Backg-2.jpg": 9045,
	"./Backg-3.jpg": 1229,
	"./Backg-4.jpg": 2984,
	"./Backg-5.jpg": 7859,
	"./Backg-6.jpg": 7559
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;